import { useMutation } from '@tanstack/react-query';
import useAxios from '../../../../../app/hooks/useAxios';
import queryClient from '../../../../../app/utils/queryClient';

const useAuthOktaFactorQuestionMutation = () => {
	const { post, remove } = useAxios();

	const setFactor = (profile: { question: string; answer: string }) => {
		return post(`/users/me/factors`, {
			factorType: 'question',
			provider: 'OKTA',
			profile,
		});
	};

	const deleteFactor = () => {
		return remove(`/users/me/factors/question/remove`);
	};

	return {
		mutateSetFactor: useMutation(setFactor, {
			onSuccess: () => {
				queryClient.invalidateQueries(['authOktaUserFactorsCatalog']);
			},
		}),
		mutateDeleteFactor: useMutation(deleteFactor, {
			onSuccess: () => {
				queryClient.invalidateQueries(['authOktaUserFactorsCatalog']);
			},
		}),
	};
};

export default useAuthOktaFactorQuestionMutation;
